export const AdminConstants = {
  FETCH_ADMIN_REQUEST: "FETCH_ADMIN_REQUEST",
  FETCH_ADMIN_SUCCESS: "FETCH_ADMIN_SUCCESS",
  FETCH_ADMIN_FAILURE: "FETCH_ADMIN_FAILURE",
  ADD_ADMIN_REQUEST: "ADD_ADMIN_REQUEST",
  ADD_ADMIN_SUCCESS: "ADD_ADMIN_SUCCESS",
  ADD_ADMIN_FAILURE: "ADD_ADMIN_FAILURE",
  ADMIN_SEARCH_REQUEST: "ADMIN_SEARCH_REQUEST",
  ADMIN_SEARCH_SUCCESS: "ADMIN_SEARCH_SUCCESS",
  ADMIN_SEARCH_FAILURE: "ADMIN_SEARCH_FAILURE",
  ADMIN_AUTO_SEARCH_REQUEST: "ADMIN_AUTO_SEARCH_REQUEST",
  ADMIN_AUTO_SEARCH_SUCCESS: "ADMIN_AUTO_SEARCH_SUCCESS",
  ADMIN_AUTO_SEARCH_FAILURE: "ADMIN_AUTO_SEARCH_FAILURE",
  GET_ADMIN_REQUEST: "GET_ADMIN_REQUEST",
  GET_ADMIN_SUCCESS: "GET_ADMIN_SUCCESS",
  GET_ADMIN_FAILURE: "GET_ADMIN_FAILURE",
  UPDATE_ADMIN_REQUEST: "UPDATE_ADMIN_REQUEST",
  UPDATE_ADMIN_SUCCESS: "UPDATE_ADMIN_SUCCESS",
  UPDATE_ADMIN_FAILURE: "UPDATE_ADMIN_FAILURE",
  DOWNLOAD_ADMIN_REQUEST: "DOWNLOAD_ADMIN_REQUEST",
  DOWNLOAD_ADMIN_SUCCESS: "DOWNLOAD_ADMIN_SUCCESS",
  DOWNLOAD_ADMIN_FAILURE: "DOWNLOAD_ADMIN_FAILURE",
  UPLOAD_ADMIN_REQUEST: "UPLOAD_ADMIN_REQUEST",
  UPLOAD_ADMIN_SUCCESS: "UPLOAD_ADMIN_SUCCESS",
  UPLOAD_ADMIN_FAILURE: "UPLOAD_ADMIN_FAILURE",
};
